import { createSelector } from 'reselect';

import { selectRegions, selectDispatches, selectCheckins } from '../domain';
import { selectEntities, denormalizeFor, Region, Dispatch, Checkin } from '../entities';

export const selectRegionEntities = createSelector([selectRegions, selectEntities], denormalizeFor([Region]));

export const selectDispatchEntities = createSelector([selectDispatches, selectEntities], denormalizeFor([Dispatch]));

export const selectCheckinEntities = createSelector([selectCheckins, selectEntities], denormalizeFor([Checkin]));
